import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { CountriesRepositoryInterface } from "../repositories/countries/countries.interface";
import { CountryResponseDto } from "../../common/dtos/country/country.response";

@Injectable({
  providedIn:"root"
})
export class CountryManager {

  constructor(
        private countryRepository: CountriesRepositoryInterface
  ) {}

  public getCountries(): Observable<CountryResponseDto> {
    return this.countryRepository.getCountries();
  }

}